import { ref, computed } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import VueCookies from "vue-cookies";
import router from "../router/router";
import { ROLES, ROLE_PERMISSIONS, PERM, normalizeRole } from '@/components/Utilities/javascripts/permissions';

export const useAuthStore = defineStore("auth", () => {
  // const userData = ref(JSON.parse(localStorage.getItem('userData')) || null);
  const userData = ref(null);
  const token = ref(null);

  const safeRole = computed(() =>
    Number.isInteger(userData.value?.role) ? userData.value.role : ROLES.guest
  );

  const permissionsMask = computed(() =>
    Number.isInteger(userData.value?.permissionsMask)
      ? userData.value.permissionsMask
      : ROLE_PERMISSIONS[safeRole.value] ?? 0
  );

  const can = (permNameOrBit) => {
    const bit = typeof permNameOrBit === "string" ? PERM[permNameOrBit] : permNameOrBit;
    return (permissionsMask.value & bit) !== 0;
  };

  const hasRole = (target) => {
    const r = userData.value?.role ?? ROLES.guest;
    return Array.isArray(target) ? target.includes(r) : r === target;
  };

  const login = async (payload) => {
    try {
      const response = await axios.post("/login", payload);
      console.log(response);
      if (response.status === 200) {
        token.value = response.data.access_token;
        VueCookies.set("token", token.value, "1d");
        axios.defaults.headers.authorization = "Bearer " + token.value;
        // router.replace("/dashboard");
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  const register = async (payload) => {
    try {
      const response = await axios.post("/register", payload);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      const response = await axios.post("/logout");
      console.log(response);
      if (response.status === 200) {
        token.value = null;
        userData.value = null;
        localStorage.removeItem("userData");
        $cookies.remove("token");
        // window.location.reload();
        router.push("/login");
        return response;
      }
    } catch (error) {
      localStorage.removeItem("userData");
      console.log(error);
    }
  };

  const getAllShelter = async (filter) => {
    console.log("sd");

    try {
      const response = await axios.get("/shelter");
      if (response.status === 200) {
        return response;
      } else {
        throw new Error("Request failed");
      }
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  };

  const submitForgotPassword = async (payload) => {
    const response = await axios.post("/forgot-password", payload);
    if ((response.status = 200)) {
      return response;
    } else {
      throw response;
    }
  };

  const resetPassword = async (payload) => {
    const response = await axios.post("/reset-password", payload);
    if ((response.status = 200)) {
      return response;
    } else {
      throw response;
    }
  };

  const getProfile = async () => {
    try {
      const response = await axios.get("profile");
      userData.value = response.data.data;

      const payload = response.data?.data ?? response.data ?? {};

      // ✅ ทำให้ role เป็นสตริงมาตรฐาน
      payload.role = normalizeRole(payload.role);

      // ✅ คิด permissionsMask
      if (typeof payload.permissionsMask !== 'number') {
        if (Array.isArray(payload.permissions)) {
          payload.permissionsMask = payload.permissions.reduce((mask, name) => {
            const bit = PERM[name];
            return bit ? (mask | bit) : mask;
          }, 0);
        } else {
          payload.permissionsMask = ROLE_PERMISSIONS[payload.role] ?? 0;
        }
      }

      // userData.value = payload;
      // localStorage.setItem('userData', JSON.stringify(payload));
      return userData.value;
    } catch (error) {
      console.log("Error fetching profile:", error);
      throw error;
    }
  };

  const updatePassword = async (payload) => {
    try {
      const response = await axios.post("/change-password", payload);
      return response.data;
    } catch (error) {
      throw error.response.data.errors;
    }
  };

  const updateProfile = async (payload, userId) => {
    try {
      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        if (payload[key] instanceof File) {
          formData.append(key, payload[key]);
        } else if (payload[key] !== undefined) {
          formData.append(key, payload[key]);
        }
      });
      // const response = await axios.post(`/user/${userId}`, formData);
      console.log(payload);
      const response = await axios.post('profile', formData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return {
    userData,
    token,
    safeRole,
    permissionsMask,
    can,
    hasRole,
    login,
    register,
    logout,
    getAllShelter,
    submitForgotPassword,
    resetPassword,
    getProfile,
    updatePassword,
    updateProfile,
  };
});
